import { combineReducers } from 'redux';

import layout from "./layout";
import user from "./users";
import product from "./product";
import profile from "./profile";

export default combineReducers({
    layout,
    user,
    product,
    profile,
});
